import React, { useState } from 'react';
import { Modal, Button as Btn, Form, Input, Card, message } from 'antd';
import colors from '../../../../share/constants/constants';
import Close from './../../../../assets/icons/close.svg';
import Button from '../../../../components/common/button';
import { createPrice, updatePrice } from '../../../../api/payment';

const HandlePriceModal = ({ onCancel, data, getPrices }) => {
  const [form] = Form.useForm();
  const [inProgress, setInProgress] = useState(false);

  const onFinish = async (bTypeObj) => {
    setInProgress(true);
    try {
      if (data?.id) {
        if (!form.isFieldsTouched(['amount', 'description'])) {
          setInProgress(false);
          onCancel();
        } else {
          const res = await updatePrice(data?.id, bTypeObj);
          if (res) {
            message.success('Subscription Updated Successfully!');
            setInProgress(false);
            getPrices();
            onCancel();
          }
        }
      } else {
        setInProgress(true);
        const payload = {
          amount: +bTypeObj.amount,
          description: bTypeObj.description,
        };
        const res = await createPrice(payload);
        if (res) {
          message.success('Subscription Added Successfully!');
          setInProgress(false);
          getPrices();
          onCancel();
        }
      }
    } catch (error) {
      setInProgress(false);
      message.error(error);
    } finally {
      setInProgress(false);
    }
  };

  return (
    <div>
      <Modal
        open={true}
        footer={null}
        closeIcon={null}
        width="436px"
        onCancel={onCancel}
      >
        <Card>
          <div className="flex">
            <h2 className="flex-1">{data?.id ? `Edit` : `Add`} Subscription</h2>
            <img
              src={Close}
              alt="Cross Icon"
              className="w-3.2 hover:cursor-pointer"
              onClick={onCancel}
            />
          </div>
          <Form form={form} onFinish={onFinish}>
            <div className="flex flex-col justify-center">
              <Form.Item
                name="amount"
                rules={[
                  { required: data?.id ? false : true, message: 'Required' },
                  {
                    pattern: data?.id ? /^(0|[1-9]\d*)(\.\d+)?$/ : /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                    message: 'minimum amount can be 1'
                  },
                ]}
                labelAlign="left"
              >
                <div>
                  <p className="text-1.4">Amount ($)</p>
                  <Input
                    type="number"
                    placeholder={'Input amount ($)'}
                    defaultValue={`${data?.price || ''}`}
                    className={'w-full h-5.4 !rounded-xl border-unset'}
                    disabled={data?.id}
                    min={1}
                    onKeyDown={(e) => {
                      if (['e', 'E', '+', '-', '0', '.'].includes(e.key)) {
                        e.preventDefault();
                      }
                  }}
                  />
                </div>
              </Form.Item>
              <Form.Item
                name="description"
                rules={[
                  { required: data?.id ? false : true, message: 'Required' },
                ]}
              >
                <div>
                  <p className="text-1.4">Description</p>
                  <Input
                    placeholder={'Enter Description'}
                    defaultValue={`${data?.description || ''}`}
                    className={'w-full h-5.4 !rounded-xl border-unset'}
                  />
                </div>
              </Form.Item>
            </div>
            <Form.Item>
              <Button
                title={data?.id ? `Update` : 'Save'}
                color={colors.primaryPurple}
                className="flex items-center w-full"
                htmlType="submit"
                onOk={onCancel}
                loading={inProgress}
              />
            </Form.Item>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};
export default HandlePriceModal;